<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-output/ScreenConfiguration' }">大屏配置</el-breadcrumb-item>
            <el-breadcrumb-item>配置详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <el-dialog :title="title " :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <!-- <el-form-item label="大屏配置ID" :label-width="formLabelWidth" v-if="isBigScreenId" >
              <el-input v-model="form.config_id" autocomplete="off" disabled></el-input>
            </el-form-item> -->
            <el-form-item label="字段名称" :label-width="formLabelWidth">
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="内容" :label-width="formLabelWidth">
              <el-input v-model="form.content" autocomplete="off" type="textarea"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="operation()">确 定</el-button>
          </div>
        </el-dialog>

        <div>
          <el-form label-width="80px">
            <el-form-item label="大屏名称">
              <template>{{BigScreenName}}</template>
            </el-form-item>
            <el-form-item label="配置字段">
              <el-col :span="6">
                <el-input v-model="keywordQuery" placeholder="请输入关键词（模糊匹配）" clearable></el-input>
              </el-col>
              <el-col :span="6" style="margin-left:10px">
                <template>
                  <el-button type="primary" @click="queryData()">查询</el-button>
                  <el-button type="primary" @click="addData()">新增字段</el-button>
                </template>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light"></div>
              </el-col>
            </el-form-item>
          </el-form>

          <el-table
            :data="tableData"
            style="width: 100%"
            :default-sort="{prop: 'date', order: 'descending'}"
            v-loading="loading"
            element-loading-text="数据加载中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255,.4)"
            element-loading-custom-class="el-loading-mask-table"
          >
            <el-table-column prop="field_name" label="字段名称" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="field_value" label="内容" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="add_time" label="创建时间" :formatter="addTime" sortable></el-table-column>
            <el-table-column prop="update_time" label="最后修改时间" :formatter="updateTime" sortable></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-row>
                  <el-button type="text" size="small" @click="editData(scope.row)">
                    <i class="el-icon-edit"></i>编辑
                  </el-button>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "./api";
import {timestampToTime} from "@/mixins/tools.js"

export default {
  mixins: [timestampToTime],
  data() {
    return {
      tableData: [],
      rowData: {},
      dialogFormVisible: false,
      isBigScreenId:true,
      loading: true,
      notarizeCallback: "",
      value: "",
      title:"",
      BigScreenName: "",
      form: {
        name: "",
        content: "",
        config_id:""
      },
      formLabelWidth: "120px",
      keywordQuery: ""
    };
  },
  created() {
    this.getData();
    this.BigScreenName = this.$route.query.BigScreenName;
  },
  methods: {
    // 获取大屏配置字段列表
    getData(data) {
      debugger
      let transmitData = {
        board_config_id:this.$route.query.configId
      }
      if(this.keywordQuery){
        transmitData.q=this.keywordQuery
      }
      this.loading = true;
      api
        .getBigScreenFieldsList(transmitData)
        .then(res => {
          this.tableData = res.list;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 操作判断
    operation() {
      if (this.value == "add") {
        let data = {
          field_name: this.form.name,
          field_value: this.form.content,
          board_config_id:this.$route.query.configId
        };
        api
          .addBigScreenFieldsData(data)
          .then(res => {
            this.$message("新增成功!");
            this.dialogFormVisible = false;
            this.getData();
          })
          .catch(err => {
            this.$message(err);
          });
      } else if (this.value == "edit") {
        let data = {
          id: this.rowData.id,
          field_name: this.form.name,
          field_value: this.form.content,
          board_config_id: this.form.config_id,
        };
        api
          .editBigScreenFieldsData(data)
          .then(res => {
            this.rowData = {};
            this.$message("修改成功!");
            this.dialogFormVisible = false;
            this.getData();
          })
          .catch(err => {
            this.$message(err);
          });
      }
    },

    // 新增字段
    addData() {
      this.dialogFormVisible = true;
      // this.isBigScreenId= true;
      this.value = "add";
      this.title = "新增字段";
      this.form = { name: "", content: "" };
    },

    // 修改数据
    editData(row) {
      this.dialogFormVisible = true;
      // this.isBigScreenId= false;
      this.value = "edit";
      this.title = "修改字段";
      this.form.name = row.field_name;
      this.form.content = row.field_value;
      this.form.config_id = row.board_config_id;
      this.rowData = row;
    }
  }
};
</script>

<style lang="scss" scoped>
.line {
  text-align: center;
  color: #8b8b8b;
}
</style>